import { createContext } from "react";

const StudentLogBookContext = createContext();

export default StudentLogBookContext;
